module.exports = __webpack_public_path__ + "img/bg_avatar_male_79.e2be3fc4.png";